import axios from '../../../../untils/request.js'
// 查询公司部门树
export async function deptTree (data, currentPage, pageSize) {
  const res = await axios({
    method: 'post',
    url: '/info/company/deptTree',
    intercept: 1,
    currentPage,
    pageSize,
    data,
    headers: {
      'Content-Type': 'application/json' //设置请求头请求格式为JSON
    }
  })
  return res.data
}
// 查询子部门列表
export async function childrenDept (data, currentPage, pageSize) {
  const res = await axios({
    method: 'post',
    url: '/info/company/childrenDept',
    intercept: 1,
    currentPage,
    pageSize,
    data,
    headers: {
      'Content-Type': 'application/json' //设置请求头请求格式为JSON
    }
  })
  return res.data
}

// 新增部门
export async function addDept (data, currentPage, pageSize) {
  const res = await axios({
    method: 'post',
    url: '/info/company/addDept',
    intercept: 1,
    currentPage,
    pageSize,
    data,
    headers: {
      'Content-Type': 'application/json' //设置请求头请求格式为JSON
    }
  })
  return res.data
}

// 修改部门名称
export async function editDept (data, currentPage, pageSize) {
  const res = await axios({
    method: 'post',
    url: '/info/company/editDept',
    intercept: 1,
    currentPage,
    pageSize,
    data,
    headers: {
      'Content-Type': 'application/json' //设置请求头请求格式为JSON
    }
  })
  return res.data
}

// 移动部门
export async function moveDept (data, currentPage, pageSize) {
  const res = await axios({
    method: 'post',
    url: '/info/company/moveDept',
    intercept: 1,
    currentPage,
    pageSize,
    data,
    headers: {
      'Content-Type': 'application/json' //设置请求头请求格式为JSON
    }
  })
  return res.data
}

// 批量删除部门
export async function batchDeleteDept (data, currentPage, pageSize) {
  const res = await axios({
    method: 'post',
    url: '/info/company/batchDeleteDept',
    intercept: 1,
    currentPage,
    pageSize,
    data,
    headers: {
      'Content-Type': 'application/json' //设置请求头请求格式为JSON
    }
  })
  return res.data
}
//   新增企业员工
export async function addEmployee (data, currentPage, pageSize) {
  const res = await axios({
    method: 'post',
    url: '/info/company/addEmployee',
    intercept: 1,
    currentPage,
    pageSize,
    data,
    headers: {
      'Content-Type': 'application/json' //设置请求头请求格式为JSON
    }
  })
  return res.data
}
//   编辑企业员工
export async function editEmployee (data, currentPage, pageSize) {
  const res = await axios({
    method: 'post',
    url: '/info/company/editEmployee',
    intercept: 1,
    currentPage,
    pageSize,
    data,
    headers: {
      'Content-Type': 'application/json' //设置请求头请求格式为JSON
    }
  })
  return res.data
}
//  地址
export async function getAddressSelect (data, currentPage, pageSize) {
  const res = await axios({
    method: 'post',
    url: '/sys/getAddressSelect',
    intercept: 1,
    currentPage,
    pageSize,
    data,
    headers: {
      'Content-Type': 'application/json' //设置请求头请求格式为JSON
    }
  })
  return res.data
}

//  查询在职、离职、回收站员工列表
export async function employeeList (data, currentPage, pageSize) {
    const res = await axios({
      method: 'post',
      url: '/info/company/employeeList',
      intercept: 1,
      currentPage,
      pageSize,
      data,
      headers: {
        'Content-Type': 'application/json' //设置请求头请求格式为JSON
      }
    })
    return res.data
}
//  公司部门树状结构 带部门人数统计
export async function deptTreeAndCount (data, currentPage, pageSize) {
    const res = await axios({
      method: 'post',
      url: '/info/company/deptTreeAndCount',
      intercept: 1,
      currentPage,
      pageSize,
      data,
      headers: {
        'Content-Type': 'application/json' //设置请求头请求格式为JSON
      }
    })
    return res.data
}
//  查询企业员工信息
export async function getEmployee (data, currentPage, pageSize) {
  const res = await axios({
    method: 'post',
    url: '/info/company/getEmployee',
    intercept: 1,
    currentPage,
    pageSize,
    data,
    headers: {
      'Content-Type': 'application/json' //设置请求头请求格式为JSON
    }
  })
  return res.data
}
//  员工批量放入回收站
export async function batchTrash (data, currentPage, pageSize) {
  const res = await axios({
    method: 'post',
    url: '/info/company/batchTrash',
    intercept: 1,
    currentPage,
    pageSize,
    data,
    headers: {
      'Content-Type': 'application/json' //设置请求头请求格式为JSON
    }
  })
  return res.data
}
//  员工批量从回收站恢复
export async function batchRestore (data, currentPage, pageSize) {
  const res = await axios({
    method: 'post',
    url: '/info/company/batchRestore',
    intercept: 1,
    currentPage,
    pageSize,
    data,
    headers: {
      'Content-Type': 'application/json' //设置请求头请求格式为JSON
    }
  })
  return res.data
}
//  员工批量彻底删除
export async function batchDelete (data, currentPage, pageSize) {
  const res = await axios({
    method: 'post',
    url: '/info/company/batchDelete',
    intercept: 1,
    currentPage,
    pageSize,
    data,
    headers: {
      'Content-Type': 'application/json' //设置请求头请求格式为JSON
    }
  })
  return res.data
}
//  员工批量彻底删除
export async function getCompanyEmployeeCount (data, currentPage, pageSize) {
  const res = await axios({
    method: 'post',
    url: '/info/company/getCompanyEmployeeCount',
    intercept: 1,
    currentPage,
    pageSize,
    data,
    headers: {
      'Content-Type': 'application/json' //设置请求头请求格式为JSON
    }
  })
  return res.data
}
//  员工管理-实习期或合同到期弹窗提醒
export async function companyPop (data, currentPage, pageSize) {
  const res = await axios({
    method: 'post',
    url: '/info/company/pop',
    intercept: 1,
    currentPage,
    pageSize,
    data,
    headers: {
      'Content-Type': 'application/json' //设置请求头请求格式为JSON
    }
  })
  return res.data
}
//  员工批量移动
export async function batchMove (data, currentPage, pageSize) {
  const res = await axios({
    method: 'post',
    url: '/info/company/batchMove',
    intercept: 1,
    currentPage,
    pageSize,
    data,
    headers: {
      'Content-Type': 'application/json' //设置请求头请求格式为JSON
    }
  })
  return res.data
}
//  发送短信、邮件验证码
export async function sendAuthCode (data, currentPage, pageSize) {
  const res = await axios({
    method: 'post',
    url: '/global/sendAuthCode',
    intercept: 1,
    currentPage,
    pageSize,
    data,
    headers: {
      'Content-Type': 'application/json' //设置请求头请求格式为JSON
    }
  })
  return res.data
}

